import { CreatePopupManager } from './popup-manager'
export function createPopoverPlugin() {
  const {
    getPopperModalInstance,
    removePopperModalInstance,
    getPoppperJsInstance,
    createPopperJsInstance,
  } = new CreatePopupManager()

  // 获取气泡组件实例，载体，body
  function getReferencePopper() {
    const popperModalInstance = getPopperModalInstance()
    const popper = popperModalInstance.$el
    const reference = popperModalInstance.reference
    return {
      popper,
      reference,
      popperModalInstance,
    }
  }
  // 创建或更新气泡
  function createPopper(reference, poppverOption) {
    const { popper } = getReferencePopper()
    const virtualTablePopperJs = getPoppperJsInstance()
    if (virtualTablePopperJs && reference) {
      // 重置设置载体
      virtualTablePopperJs._reference = reference
      virtualTablePopperJs._popper = popper
      // 更新时会重新计算
      setTimeout(() => {
        virtualTablePopperJs.update()
      })
    } else {
      if (!popper || !reference || popper.nodeType === 8) return
      const { placement = 'top', offset = 0, arrowOffset = 0 } =
        poppverOption || {}
      const options = {
        placement,
        offset,
        arrowOffset,
      }
      createPopperJsInstance(reference, popper, options)
      const virtualTablePopperJs = getPoppperJsInstance()
      virtualTablePopperJs.onCreate((_) => {
        setTimeout(() => {
          virtualTablePopperJs.update()
        })
      })
    }
  }
  function updatePopper () {
    const virtualTablePopperJs = getPoppperJsInstance()
    if (virtualTablePopperJs) {
      virtualTablePopperJs.update()
    }
  }
  // 销毁popper
  function destroyPopver() {
    const virtualTablePopperJs = getPoppperJsInstance()
    if (virtualTablePopperJs) {
      virtualTablePopperJs.destroy()
    }
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      removePopperModalInstance()
    }
  }

  // 显示气泡或更新气泡
  function showPoppver(reference, poppverMergeOptions, trigger = 'hover') {
    if (!reference) {
      return
    }
    const popperModalInstance = getPopperModalInstance()
    const { isTouchContent } = poppverMergeOptions
    assignPopoverOptions(reference, poppverMergeOptions)
    if (!isTouchContent) {
      popperModalInstance.handleMouseEnter()
    } else {
      popperModalInstance.$nextTick(() => {
        if (!popperModalInstance.value) {
          popperModalInstance.handleMouseEnter()
        }
      })
    }
    trigger === 'hover' && popperModalInstance.handleEvent()
    const { placement = 'top', arrowOffset = 0, offset = 0 } = poppverMergeOptions || {}
    createPopper(reference, {
      placement,
      offset,
      arrowOffset,
    })
  }
  // 合并气泡的props
  function assignPopoverOptions(reference, poppverMergeOptions) {
    const popperModalInstance = getPopperModalInstance()
    for (let prop in poppverMergeOptions) {
      if (poppverMergeOptions.hasOwnProperty(prop)) {
        popperModalInstance[prop] = poppverMergeOptions[prop]
      }
    }
    popperModalInstance.reference = reference
  }

  // 同步隐藏气泡
  function hiddenPopover() {
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      popperModalInstance.clearTimerTimeout()
      popperModalInstance.value = false
    }
  }
  // 移除气泡的监听
  function removePopperHandleEvent () {
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      popperModalInstance.removeHandleEvent()
    }
  }
  // 异步隐藏气泡
  function asyncHiddenPopover () {
    const popperModalInstance = getPopperModalInstance()
    if (popperModalInstance) {
      popperModalInstance.handleMouseLeave()
    }
  }

  return {
    destroyPopver,
    showPoppver,
    hiddenPopover,
    createPopper,
    getPopperModalInstance,
    removePopperHandleEvent,
    asyncHiddenPopover,
    updatePopper
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/popover/popover.js